import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import arrowLeftIcon from '../../asset/img/common/detail_arrow_left_icon.svg';
import Typography from '../common/Typography';

const HeaderStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 16px;
  justify-content: center;
  height: 64px;
  background-color: #fff;
  border-bottom: 1px solid var(--GrayScale-400);
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100vw;
  left: 0;
  gap: 16px;
  .title {
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
  }
`;

const WithoutXHeader = ({ title = '' }) => {
  const navigate = useNavigate();

  return (
    <HeaderStyled>
      <Typography className="title">{title}</Typography>
    </HeaderStyled>
  );
};

export default WithoutXHeader;
